import React, { FC, useEffect, useState } from "react";
import { Input, Button, Modal, Row, Col, Spin, Avatar, List, Checkbox } from "antd";
import _ from "lodash";

import { SearchOutlined } from "@ant-design/icons";
import { RootState } from "reducers/rootReducer";
import { useDispatch, useSelector } from "react-redux";
import { getFriendUserInfo, isScrollbarAtBottom, getAvatar } from "utils/chatUtils";
import {
    getPageSearchArgument,
    wrapRequestPayload,
} from "../../../helpers/request/RequestPayload";
import { formatForRedis, generateUUID } from "utils/appUtil";
import { PageTopics, SocketTopics } from "../../../constants/enums";
import MessageBox from "./MessageBox";
import { MessageTypes } from "../../../constants/enums";





const ForwardMessagePopup: FC<{
    onClose?: () => void;
    message: MessageObj,
    allUsers: UserInfo[],
    onSend: (page: SelectedSearchItem, message: MessageObj) => void;
    socket: ISocket
}> = ({
    onSend,
    onClose,
    message,
    allUsers,
    socket,
}) => {
        const { forwardPopupPagesResult, forwardPopupSearchPage, forwardSearchArgs } = useSelector(
            (state: RootState) => state.search
        );
        const dispatch = useDispatch();

        const [isModalVisible, setIsModalVisible] = useState<boolean>(true);
        const [isLoading, setIsLoading] = useState(false);
        const [isSearchLoading, setIsSearchLoading] = useState(true);
        const useMounted = () => {
            const [isForwardMounted, setIsForwardMounted] = useState(false);
            useEffect(() => {
                setIsForwardMounted(true);
            }, []);
            return isForwardMounted;
        };
        const isForwardMounted = useMounted();

        const searchPageQuery = (offset = 0, limit = 10, searchArgs = undefined) => {
            const searchArguments = getPageSearchArgument(
                searchArgs?.search,
                searchArgs?.args
            );
            const {
                load,
                searchIndex,
                searchQuery,
                sortByProperties,
                filterExpression,
            } = searchArguments;

            const requestId = generateUUID();
            localStorage.setItem("pageRequestId", requestId);
            const pageRequest = {
                select: {
                    index: {
                        searchIndex,
                        searchQuery: searchQuery + `@partitions:{'org\\:${formatForRedis(
                            localStorage.getItem("selectedOrg") || "cudb-live"
                        )}'}`,
                        searchOptions: "TIMEOUT 10000",
                    },
                    list: {},
                    load,
                },
                apply: {
                    expression: "",
                    name: "",
                },
                result: {
                    pagination: {
                        offset,
                        limit,
                    },
                },
                sortBy: {
                    properties: sortByProperties,
                    max: offset + limit,
                },
                filter: {
                    expression: filterExpression,
                },
                anyStatus: false,
            };
            socket.publishToEvent(
                SocketTopics.PublishPageTopics,
                `${process.env.REACT_APP_ECO_SYSTEM}/connection/${localStorage.getItem(
                    "CID"
                )}/service/bds/aggregateBds`,
                wrapRequestPayload(pageRequest, PageTopics.FowardMessagePopup),
            );
        };
        useEffect(() => {
            if (isModalVisible) {
                searchPageQuery();
            }
        }, [isModalVisible]);

        useEffect(() => {
            if (forwardSearchArgs && isForwardMounted) {
                searchPageQuery(forwardPopupSearchPage.offset, forwardPopupSearchPage.limit, forwardSearchArgs);
            }
        }, [forwardSearchArgs]);


        useEffect(() => {
            if (forwardPopupPagesResult) setIsSearchLoading(false);
            setIsLoading(false);
        }, [forwardPopupPagesResult]);

        const handleCancel = () => {
            setIsModalVisible(false);
            onClose && onClose();
        };
        const handleOk = () => {
            setIsModalVisible(false);
        };
        let searchTimeout;
        const searchPageRequest = (search) => {
            if (searchTimeout) clearTimeout(searchTimeout);
            searchTimeout = setTimeout(() => {
                dispatch({
                    type: "SEARCH_FORWARD_PAGES_LIST",
                    payload: { paginate: false, search, reset: true },
                });
            }, 1000);
        };
        const handleOnSend = (page: SelectedSearchItem, index: number) => {
            forwardPopupPagesResult[index]["sent"] = true;
            onSend(page, message);
        }
        return (
            <Modal
                title="Forward to..."
                visible={isModalVisible}
                onOk={handleOk}
                onCancel={handleCancel}
                width="400px"
                className="beam-modal"
                footer={[]}
                destroyOnClose={true}
                maskClosable={false}
                keyboard={false}
            >
                <div role="none" className="forward-comman forward-comman-in mb-2 bg-white">
                    <div role="none" className="forward-comman quote-cover p-2"
                    >
                        <MessageBox hideCheck={true} truncateLength={150} message={message} />
                        <span>
                            {message.messageType === MessageTypes.Media && (
                                <img
                                    onClick={() => window.open(message.data.urls.original.url, "_blank")}
                                    className="ml-2 message-type cursor-pointer"
                                    src={`/images/${message.messageType}-icon.png`}
                                />
                            )}
                        </span>
                    </div>
                </div>
                <div role="none" className="forward-comman mb-2">
                    <Input
                        className="beam-input"
                        placeholder="Search Pages & Users"
                        onChange={(e) => {
                            setIsSearchLoading(true);
                            searchPageRequest(e.target.value);
                        }}
                        suffix={<SearchOutlined />}
                    />
                </div>
                {isSearchLoading && (<div className="loading">
                    <Spin className="mt-3" tip="Loading">
                        <div className="content" />
                    </Spin>
                </div>)}
                <div className="main-column">
                    <div className="main-content">
                        <div className="main-cards mt-0 p-0" style={{ height: '300px' }}
                            onScroll={(e: any) => {
                                const bottom = isScrollbarAtBottom(e.target);
                                if (bottom && forwardPopupSearchPage.scroll && !isLoading) {
                                    setIsLoading(bottom);
                                    dispatch({ type: "SEARCH_FORWARD_PAGES_LIST", payload: { paginate: true } });
                                }
                                e.stopPropagation();
                            }}
                        >
                            {
                                forwardPopupPagesResult?.map(
                                    (item, index) =>
                                        <Row className="person-item pb-2 pt-2" key={index}>
                                            <Col span={3}>
                                                <img
                                                    src={getAvatar(item)}
                                                    width="30"
                                                    height="45"
                                                />
                                            </Col>
                                            <Col span={17}>
                                                <h5 style={{ fontSize: "small" }}>
                                                    {item?.persistent?.static?.metadata?.title ||
                                                        (item?.persistent?.static?.metadata?.type === "friend" &&
                                                            getFriendUserInfo(allUsers, item?.persistent?.static?.metadata?.members?.users)
                                                                ?.beamId
                                                            ? getFriendUserInfo(allUsers,
                                                                item?.persistent?.static?.metadata?.members?.users
                                                            )?.beamId
                                                            : `Page ${item?.pageId}`)}
                                                </h5>
                                            </Col>
                                            <Col span={2} className="t-right">
                                                <React.Fragment>
                                                    <Button
                                                        type={!item["sent"] ? "primary" : "default"} size="small" disabled={item["sent"]}
                                                        className="beam-btn green-btn"
                                                        onClick={() => handleOnSend(item, index)}
                                                    >
                                                        <small>{item["sent"] ? "Sent" : "Send"}</small>
                                                    </Button>
                                                </React.Fragment>
                                            </Col>
                                        </Row>
                                )}
                            {isLoading && (<div className="loading">
                                <Spin tip="Loading">
                                    <div className="content" />
                                </Spin>
                            </div>)}
                        </div>
                    </div>
                </div>
            </Modal>
        );
    };

export default ForwardMessagePopup;
